import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'

export function getGenderSelection(t: TFunction): OnboardingStep {
  return {
    id: 'gender',
    type: 'custom',
    wordings: {
      title: ''
    }
  }
}
